export default "__VITE_ASSET__BnZ7Y1Ar__"